<template>
<div id="root">
     <vs-table v-if="isMounted" ref="table" stripe description description-title="Angezeigt" description-connector="von"
      description-body="Einträgen" pagination :max-items="itemsPerPage" search :data="ordersOrderedNotPaid">
      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
        <h3>
            Bezahlung hat nicht funktioniert
        </h3>
      </div>

      <template slot="thead">
        <vs-th sort-key="_id">ID</vs-th>
        <vs-th sort-key="createdAt">Bezahlt am</vs-th>
        <vs-th sort-key="totalPrice">Preis</vs-th>
        <vs-th>Aktionen</vs-th>
      </template>

        <template slot-scope="{data}">
          <tbody>
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

              <vs-td>
                <p class="product-name font-medium truncate">{{ tr._id }}</p>
              </vs-td>

              <vs-td>
                <p class="product-category">{{ tr.createdAt | moment("DD.MM.YYYY HH:mm")}}</p>
              </vs-td>

              <vs-td>
               <p>{{tr.totalPrice.toFixed(2)}}€</p>
              </vs-td>


              <vs-td class="whitespace-no-wrap">

                <feather-icon class="mr-4" :id="'details-' + tr._id" icon="InfoIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" @click="showDetails(tr)" />
              </vs-td>

            </vs-tr>
          </tbody>
        </template>
    </vs-table>


<!-- POPUP TO SHOW DETAILED DATA-->
<vs-popup fullscreen v-if="selectedItem" class="holamundo" title="Details zur Lieferung" :active.sync="popupActive">
    <div id="popup">
    <p class="font-bold">Adresse:</p>
    <p>{{selectedItem.shippingAddress.fullName}}</p>
    <p>{{selectedItem.shippingAddress.address}}</p>
    <p>{{selectedItem.shippingAddress.postalCode}} {{selectedItem.shippingAddress.city}}</p>
    <p class="font-bold mt-4">Telefon:</p>
    <p>{{selectedItem.shippingAddress.mobileNum}}</p>
    <p v-if="selectedItem.shippingAddress.notes" class="font-bold mt-4">Hinweise vom Kunden:</p>
    <p>{{selectedItem.shippingAddress.notes}}</p>
    <p class="font-bold mt-4">Bestellung:</p>
    <br>
    <div class="ml-4" v-for="(order,index) in selectedItem.orderItems" :key="index">
        <p class="font-bold">{{order.name}}</p>
        <p>Anzahl: {{order.qty}}</p>

        <div v-if="order.ingredients['0'].sauces.length > 0">
        <p>Saucen:
        <span v-for="(sauce,index) in order.ingredients['0'].sauces" :key="index">
                 <span>{{sauce.label}}</span>
        </span>
        </p>
        </div>
       
         <div v-if="order.ingredients['2'].meats.length > 0">
        <p>Fleisch:
        <span v-for="(meat,index) in order.ingredients['2'].meats" :key="index">
                 <span>{{meat.label}}</span>
        </span>
        </p>
         </div>

         <div v-if="order.ingredients['1'].salads.length > 0">
        <p>Salate:
        <span v-for="(salad,index) in order.ingredients['1'].salads" :key="index">
                 <span>{{salad.label}}</span>
        </span>
        </p>
         </div>

        <div v-if="order.ingredients['3'].extras.length > 0">
        <p>Extras:
        <span v-for="(extra,index) in order.ingredients['3'].extras" :key="index">
                 <span>{{extra.label}}</span>
        </span>
        </p>
        </div>

        <div v-if="order.ingredients['4'].pommRice">
          <p>Beilage:
            <span> {{order.ingredients['4'].pommRice.label}}
            </span>
          </p>
        </div>

         <div v-if="order.ingredients['5'].drink">
          <p>Beilage:
            <span> {{order.ingredients['5'].drink.label}}
            </span>
          </p>
        </div>

        <br>
    </div>
</div>
    </vs-popup>

    </div>
  
</template>

<script>

import { mapActions } from 'vuex'

export default {
data() {
    return {
      itemsPerPage: 10,
      isMounted: false,
      popupActive: false,
      selectedItem: null
    }
},
computed : {

     ordersOrderedNotPaid() {
        return this.$store.state.orders.ordersOrderedNotPaid || []
    },
},
created() {
    this.getOrdersOrderedNotPaid();
},
mounted() {
    this.isMounted = true
},
methods: {
    ...mapActions({
      getOrdersOrderedNotPaid: "orders/getOrderedNotPaidOrders",
    }),
    showDetails(item) {
        this.selectedItem = item,
        this.popupActive = true
    }
   
}
}
</script>

<style>

</style>